import React, { useEffect } from "react";
import {
   Route,
   Routes,
   BrowserRouter,
   useLocation,
   Navigate,
} from "react-router-dom";
import { getCookie } from "cookies-next";

import Index from "./screens";
import BTCWithdrawalScreen from "./screens/BTCWithdrawalScreen";
import DashboardScreen from "./screens/DashboardScreen";
import DepositBTCScreen from "./screens/DepositBTCScreen";
import NotFoundScreen from "./screens/NotFoundScreen";
import DepositRequestScreen from "./screens/BTCDepositRequestsScreen";
import BTCWithdrawalRequestScreen from "./screens/BTCWithdrawalRequestScreen";
import UsersScreen from "./screens/Users";
import RedemedScreen from "./screens/redemed";
const Routing: React.FunctionComponent = () => {
   return (
      <BrowserRouter>
         <ScrollToTop>
            <Routes>
               <Route
                  path="/"
                  element={
                     <PreventMultiLogin>
                        <Index />
                     </PreventMultiLogin>
                  }
               />
               <Route path="*" element={<NotFoundScreen />} />
               <Route
                  path="/btc-withdrawal"
                  element={
                     <ProtectUserRoutes>
                        <BTCWithdrawalScreen />
                     </ProtectUserRoutes>
                  }
               />
               <Route
                  path="/dashboard"
                  element={
                     <ProtectUserRoutes>
                        <DashboardScreen />
                     </ProtectUserRoutes>
                  }
               />
               <Route
                  path="/btc-deposit"
                  element={
                     <ProtectUserRoutes>
                        <DepositBTCScreen />
                     </ProtectUserRoutes>
                  }
               />
               
               <Route
                  path="/btc-deposit-requests"
                  element={
                     <ProtectAdminRoutes>
                        <DepositRequestScreen />
                     </ProtectAdminRoutes>
                  }
               />
               <Route
                  path="/users"
                  element={
                     <ProtectAdminRoutes>
                        <UsersScreen />
                     </ProtectAdminRoutes>
                  }
               />
               <Route
                  path="/redemes"
                  element={
                     <ProtectAdminRoutes>
                        <RedemedScreen />
                     </ProtectAdminRoutes>
                  }
               />
               <Route
                  path="/btc-withdrawal-requests"
                  element={
                     <ProtectAdminRoutes>
                        <BTCWithdrawalRequestScreen />
                     </ProtectAdminRoutes>
                  }
               />
            </Routes>
         </ScrollToTop>
      </BrowserRouter>
   );
};

const ScrollToTop = ({ children }: any): any => {
   const location = useLocation();
   useEffect(() => {
      window.scrollTo(0, 0);
   }, [location]);
   return children;
};

const ProtectUserRoutes = ({ children }: any) => {
   const userS: any = getCookie("user");
   const user = userS ? JSON.parse(userS) : null;
   console.log(getCookie("user"),"From protected routes", userS, "Users_____",user);
   if (!user) {
      return <Navigate to="/"  />;
   } 
   return children;
};

const ProtectAdminRoutes = ({ children }: any) => {
   const userS: any = getCookie("user");
   const user = userS ? JSON.parse(userS) : null;
   if (!user?.isAdmin) {
      return <Navigate to="/dashboard" replace />;
   } else return children;
};

const PreventMultiLogin = ({ children }: any) => {
   const userS: any = getCookie("user");
   const user = userS ? JSON.parse(userS) : null;
   if (user) {
      return <Navigate to="/dashboard" replace />;
   } else return children;
};

export default Routing;
